import {IntermediatePart} from "../../intermediatePart";
import Config from "../../../../../config";
import { Vanity } from "../../parts/vanity";
import {METADATA} from "../../constants";

export default class Sink extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_sink';
    this.partName = 'Sink';
    this.translateId = "visualizer.bathroom.vanity.vanity_sink";
    this.homePageTitle = 'Sinks';
    this.visible = [Vanity.Types.Custom];
    if (Config.isDevMode()) {
      this.canBeDisabled = true;
    }
  }

  load(dbFeature) {
    if (!dbFeature.metaData["SinkSize"]) {
      dbFeature.metaData["SinkSize"] = [METADATA.Inner]
    }
    return super.load_(dbFeature, new Sink())
  }
  //
  // navigationSubItems(filters, searchText) {
  //   const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
  //   return super.navigationSubItemsWithFilterWithInactive('VanitySize', this.getParent().counterTopSize(), filteredAvailableFeatures);
  // }

  disabledClick() {
    this.getParent().toggleVanityParts(this.disabled);
  }

  // getArrayOfConditions() {
  //   const counterTopSize = this.getParent().counterTopSize();
  //   return [{
  //     propName: 'VanitySize',
  //     propValue: counterTopSize
  //   }];
  // }

  handleChangeParent(nonCompatibleWith) {
    if (nonCompatibleWith === "faucet") {
      // some additional logic if needed
    } else {
      this.getParent().getParent().vanityCabinet.setActiveFeatureByFilter("Size", this.metaData["VanitySize"] ? this.metaData["VanitySize"][0] : null); // "60in", etc.
    }
  }

  setActiveFeatureByFilter(filterName, filterValue) {
    const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions());
    const filteredFeatures = featuresToDisplay.filter((feature) => {
      return feature.metaData[filterName] && feature.metaData[filterName].includes(filterValue);
    });
    if (!super.tryToSetTheSameFeature(filteredFeatures)) {
      this.activeFeature = filteredFeatures.find(feature => !feature.dbFeature.displayName.includes("laceholder")) || filteredFeatures[0];
      const placeholderAvailableFeatures = filteredFeatures.filter(feature => {
        return feature.dbFeature.displayName.includes("laceholder")
      });
      this.placeholderFeature = placeholderAvailableFeatures[0];
    }
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.getParent().activeSubType_ === Vanity.Types.Custom) {
      if(this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndexes.Vanity.Sink;
      }
      if(this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndexes.Vanity.Sink;
      }
    }
  }
}
